import classNames from 'classnames';
import { isUndefined } from 'lodash-es';
import { Info } from 'phosphor-react';
import type { PropsWithChildren } from 'react';
import { Tooltip } from '../../tooltip';

type LabelProps = {
  labelPosition?: 'left' | 'top';
  label: string;
  tooltip?: string;
  className?: string;
  as?: 'label' | 'div';
};

export const Label = ({ as: Element = 'label', label, labelPosition = 'left', tooltip, className, children }: PropsWithChildren<LabelProps>) => (
  <Element className={classNames(className, 'flex', {
    'flex-col': labelPosition === 'top',
    'items-center': labelPosition === 'left',
  })}>
    <LabeltextWithTooltip tooltip={tooltip} text={label} className={classNames({
      'mr-150': labelPosition === 'left',
      'mb-50': labelPosition === 'top',
    })} />
    {children}
  </Element>
);

type LabeltextWithTooltipProps = {
  text: string;
  tooltip?: string;
  className?: string;
};

const LabeltextWithTooltip = ({ text, tooltip, className }: LabeltextWithTooltipProps) => {
  return (
    <div className={classNames(
      'tds-input-label flex gap-100 items-center',
      className,
    )}>
      {text}
      {isUndefined(tooltip) ? null : <Tooltip content={tooltip}><Info size={20} /></Tooltip>}
    </div>
  );
};
